import React, { useCallback, useEffect } from 'react';
import { checkRecoveryTokenAPI } from '../../../Api/RecoveryPasswordFormModuleAPI';
import { Alert, Box, LinearProgress } from '@mui/material';

interface Props {
  token: string;
  successAction: () => void;
}

const CheckTokenView: React.FC<Props> = ({ token, successAction }) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<boolean>(false);

  const toCheckTokenHandle = useCallback(async () => {
    try {
      setLoading(true);
      setError(false);
      await checkRecoveryTokenAPI(token);

      successAction();
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [token, successAction]);

  useEffect(() => {
    toCheckTokenHandle();
  }, [toCheckTokenHandle]);

  if (loading) {
    return <LinearProgress color="primary" sx={{ height: '30px' }} />;
  }

  if (error) {
    return (
      <Alert
        variant="standard"
        severity="error"
        sx={{
          fontSize: '8pt',
        }}
      >
        <Box>
          <b>Oops!</b>&nbsp; Your token failed verified.
        </Box>
      </Alert>
    );
  }

  return (
    <Alert
      variant="standard"
      severity="success"
      sx={{
        fontSize: '8pt',
      }}
    >
      <Box>
        <b>Nice!</b>&nbsp; Your token has been verified..
      </Box>
    </Alert>
  );
};

export default CheckTokenView;
